export default class PartitionLag {
  partitionNumber: number;

  lag: number;

  constructor(obj: any = {}) {
    this.partitionNumber = obj.partitionNumber || 0;
    this.lag = obj.lag || 0;
  }
}
